import * as React from "react";

const IconTextLinkEditInactive: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 13"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fill="currentColor"
                d="M11.67 2.238L10.26.83a1.126 1.126 0 00-1.591 0L7.344 2.155l2.979 3 1.325-1.325c.462-.44.462-1.152.021-1.592zm-4.854.447L.729 8.772a.375.375 0 00-.103.191L.01 12.05a.375.375 0 00.44.443l3.086-.617a.375.375 0 00.192-.103l6.087-6.087-2.998-3z"
                opacity=".66"
            />
        </svg>
    );
};

export default React.memo(IconTextLinkEditInactive);
